import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild, signal } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BandeiraCartaoService } from 'src/app/service/bandeira-cartao.service';
import { ReciboService } from 'src/app/service/recibo.service';
import { StorageService } from 'src/app/service/shared/storage.service';
import Tools from 'src/app/util/Tools';


const FORMAS_ENTREGA: any = [
  {
    id_forma: 1,
    descricao: 'Na Escola',
  },
  {
    id_forma: 2,
    descricao: 'Sedex',
  },
  {
    id_forma: 3,
    descricao: 'PAC',
  },
  {
    id_forma: 4,
    descricao: 'Entrega Local',
  }
]

@Component({
  selector: 'app-finalizacao',
  templateUrl: './finalizacao.component.html',
  styleUrls: ['./finalizacao.component.scss']
})

export class FinalizacaoComponent implements OnInit, AfterViewChecked {
  public readonly aba: string = 'finalizacao';

  public dependentes: any = [];

  public nome_escola: string = 'Carregando informações...';

  public numero_pedido: number = this.storage.getIdPedido();

  public nome_responsavel!: string;

  public totalPorDependente: any = [];
  public frete: number = 0;
  public total!: any;

  public prazo_entrega!: string;

  public forma_pagamento!: number;

  public parcela!: string;

  public endereco!: string;

  public linkBoleto!: string;

  caminhoBandeira!: string;

  public isLoading: boolean = true;

  public validadeTexto = signal<string>('');
  public pixCopiaCola = signal<string | number>('');
  public qrCodeImgBase64 = signal<string>('');

  public displayedColumns: string[] = [
    'desc_produto',
    'valor',
  ];
  public dataSource!: MatTableDataSource<any>;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('conteudoParaImprimir') conteudoParaImprimir!: ElementRef;


  constructor(
    private router: Router,
    private storage: StorageService,
    private recibo: ReciboService,
    private bandeiraCartao: BandeiraCartaoService,
    private sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
    if (!this.numero_pedido) {
      this.router.navigate(['/dependente']);
    } else {
      this.carregaResumoDependentes();
    }
  }

  ngAfterViewChecked(): void {
    if (this.numero_pedido) {
      this.storage.clean();
    }
  }

  private carregaResumoDependentes() {
    this.recibo.recibo(this.storage.getIdPedido()).subscribe({
      next: (pedido) => {
        this.dependentes = pedido.lista;
        this.dataSource = new MatTableDataSource<any>(this.dependentes);
        this.dataSource.sort = this.sort;
        this.isLoading = false;
        this.operacaoTotalPorDependente()

        this.nome_escola = pedido.pedido.escola.nome_escola;
        this.nome_responsavel = pedido.pedido.nome_responsavel;
        this.prazo_entrega = 'Verificar data de entrega com a escola: ' + Tools.formatarTelefone(pedido.pedido.telefone_ent);
        this.endereco = `${pedido.pedido.endereco_ent}, ${pedido.pedido.numero_ent} - ${pedido.pedido.bairro_ent} - ${pedido.pedido.cidade_ent} - ${pedido.pedido.estado_ent} CEP: ${Tools.formatarCep(pedido.pedido.cep_ent)}`;
        this.parcela = pedido.pagamento.parcela;
        this.forma_pagamento = pedido.pedido.id_forma_pagamento;

        this.linkBoleto = pedido.pagamento.url;
        this.pegaBandeira(pedido.pagamento.id_administradora);
        this.pixCopiaCola.set(pedido.pagamento.qr_code);
        this.qrCodeImgBase64.set(pedido.pagamento.qr_code_img);

      const agora = new Date();
      const validade = new Date(agora.getTime() + 2 * 60 * 60 * 1000); // +2 horas

        this.validadeTexto.set(
          `Válido até ${validade.getDate().toString().padStart(2, '0')}/` +
          `${(validade.getMonth() + 1).toString().padStart(2, '0')}/` +
          `${validade.getFullYear()} às ` +
          `${validade.getHours().toString().padStart(2, '0')}:` +
          `${validade.getMinutes().toString().padStart(2, '0')}`
        );
      },
      error: (err) => {
        console.error('Erro ao carregar o recibo:', err);
        this.isLoading = false;
        this.router.navigate(['/info-erro']);
      }
    });
  }

  public pegaBandeira(id_administradora: number) {
    // Chame o serviço para obter a bandeira do cartão e atualizar o ícone
    this.caminhoBandeira = this.bandeiraCartao.getCardBrandForId(id_administradora).caminho;
  }

  public operacaoTotalPorDependente() {
    // Inicializa o totalPorDependente como um objeto vazio
    this.totalPorDependente = {};

    this.dependentes.forEach((dependente: any) => {
      let soma = 0;

      // Verifica se há produtos para o dependente antes de calcular a soma
      if (dependente.produtos && dependente.produtos.length > 0) {
        dependente.produtos.forEach((produto: any) => {
          soma += parseFloat(produto.valor_total);
        });
      }

      // Atualiza o totalPorDependente apenas se houver produtos selecionados
      this.totalPorDependente[dependente.id_dependente] = soma;
    });

    // Calcula a soma total de todos os valores em totalPorDependente
    this.total = Object.values(this.totalPorDependente).reduce((acc: any, value) => acc + value, 0);
  }

  imprimeRecibo() {
    window.print();
  }
  imprimeBoleto() {
    window.open(this.linkBoleto, '_blank');
  }
}
